var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-card-code', [_c('b-card-title', [_vm._v("Latest Activity")]), _c('div', {
    ref: "scrollContainer",
    staticClass: "log-scrollable",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_c('b-card', {
    staticClass: "justify-content-center align-items-center"
  }, [_vm.activityLog.length > 0 ? _c('app-timeline', [_vm._l(_vm.activityLog, function (log, index) {
    return _c('app-timeline-item', {
      key: index,
      attrs: {
        "variant": "primary"
      }
    }, [_c('div', {
      staticClass: "d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
    }, [_c('span', {
      staticStyle: {
        "cursor": "pointer"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.formatLogTitle(log))
      },
      on: {
        "click": function click($event) {
          var _log$lead, _log$lead$data;
          return _vm.openLeadDetails(log === null || log === void 0 ? void 0 : (_log$lead = log.lead) === null || _log$lead === void 0 ? void 0 : (_log$lead$data = _log$lead.data) === null || _log$lead$data === void 0 ? void 0 : _log$lead$data.id);
        }
      }
    }), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(_vm.formatDateTime(log === null || log === void 0 ? void 0 : log.created_at)))])])]);
  }), _vm.loading ? _c('div', {
    staticClass: "text-center my-2"
  }, [_c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Loading..."
    }
  })], 1) : _vm._e()], 2) : _c('div', [_c('b', [_vm._v("No Activity Found")])])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }